'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { Tooltip, Typography } from 'src/components/PulseUI';

interface DateRangeLabelProps {
  label?: string;
  tooltipText?: string;
}

const DateRangeLabel = ({ ...props }: DateRangeLabelProps) => {
  return (
    <Typography
      variant="body2"
      className="text-sm font-semibold text-gray-700 gap-2 flex items-center mb-1"
      data-testid="date-range-label"
    >
      {props?.label || 'Date Range'}
      <Tooltip
        content={
          props?.tooltipText || 'This field is required to complete the form'
        }
        position="bottom"
      >
        <Icon
          icon={faInfoCircle}
          className="text-gray-500 cursor-pointer"
          aria-label="More information"
          data-testid="date-range-label-tooltip-icon"
        />
      </Tooltip>
    </Typography>
  );
};

export default DateRangeLabel;
